import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'myFilter',
    pure: false
})
@Injectable()
export class MyFilterPipe implements PipeTransform {
    tmp = [];
    transform(items: any[], field: string, value: string): any[] {
        if (!items || items.length <= 0) {
            return [];
        }

        return items.filter((item) => new RegExp(value.toLowerCase()).test(item[field].toLowerCase()));
        // return items.filter(it => it[field] === value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/filter/filter.pipe.ts